export const isVimeo = (url: string): boolean => url.includes('vimeo.com');
